<template>
  <sui-page>
    <sui-page-header :pageId="contextPageId" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SEARCH_COND')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="codeSelectSearchCond"
              v-model="queryData.postSearchCond"
              :defaultOption="'all'"
              codeId="COD_BBS_SCH_COND_PSTNG"
              class="width60"
            />
            <div class="comp_spacing" />
            <sui-text-field
              v-model="queryData.searchText"
              :disabled="false"
              :readonly="false"
              @keyup.enter="onClickSearch"
              @keyup="onKeyUpInput()"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_RGST_DT')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-range-date-picker
              ref="datePicker"
              v-model="rangeDate"
              :value="rangeDate"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_STT')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="codeSelectStatus"
              v-model="queryData.status"
              :defaultOption="'all'"
              :initialSelectedIndex="2"
              codeId="COD_NOTICOBJ_APPR_STT"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onClickReset"
          >
            {{ $t('MSG_BTN_RESET') }}
          </sui-button>
          <sui-button
            v-permission:read="contextPageId"
            type="button"
            class="comm_btn_Scr"
            @click="onClickSearch"
          >
            {{ $t('MSG_BTN_SEARCH') }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="grid"
        :hideheader="false"
        :columns="gridColumns0"
        :dataset="'dataset0'"
        :initialPagesize="10"
        :showDisplayCountControl="true"
        :pageable="false"
        @rowselect="onSelectRow"
      />
      <div class="comm_btn_wrap">
        <sui-button
          type="button"
          class="comm_sbtn_solid"
          :disabled="rejectPermission"
          @click="onClickCancel()"
        >
          {{ $t('MSG_BTN_CANCEL') }}
        </sui-button>
      </div>
    </sui-page-contents>
  </sui-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CLB_00005', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  data() {
    return {
      queryData: {
        postSearchCond: '',
        searchText: '',
        status: '',
      },
      rangeDate: {
        from: '',
        to: '',
      },
      searchOldText: '',
      showDetailPopup: false,
      rejectPermission: true,
      postId: '',
      bbsName: '',
      bbsId: '',
      strUgrnYn: this.$t('MSG_TXT_UGRN'),
      strAnnmYn: this.$t('MSG_TXT_ANNM'),
    };
  },
  computed: {},
  watch: {},
  datasets: [{
    id: 'dataset0',
    type: 'local',
    data: 'localdata0',
    datafields: [
      {
        name: 'rowNumber',
        type: 'number',
        map: 'rowNumber',
      },
      {
        name: 'bbsId',
        type: 'string',
        map: 'bbsId',
      },
      {
        name: 'bullBoardName',
        type: 'string',
        map: 'bullBoardName',
      },
      {
        name: 'boardCategoryGroupName',
        type: 'string',
        map: 'boardCategoryGroupName',
      },
      {
        name: 'boardCategoryItemName',
        type: 'string',
        map: 'boardCategoryItemName',
      },
      {
        name: 'title',
        type: 'object',
        map: 'title',
      },
      {
        name: 'registrantName',
        type: 'string',
        map: 'registrantName',
      },
      {
        name: 'firstRegistrationDTM',
        type: 'string',
        map: 'firstRegistrationDTM',
      },
      {
        name: 'statusDisplay',
        type: 'object',
        map: 'statusDisplay',
      },
      {
        name: 'statusDes',
        type: 'string',
        map: 'statusDes',
      },
      {
        name: 'status',
        type: 'string',
        map: 'status',
      },
      {
        name: 'postId',
        text: 'postId',
        datafield: 'postId',
      },
      {
        name: 'attchDocId',
        type: 'object',
        map: 'attchDocId',
      },
      {
        name: 'urgentYn',
        type: 'string',
        map: 'urgentYn',
      },
      {
        name: 'announcementYn',
        type: 'string',
        map: 'announcementYn',
      },
      {
        name: 'finalModificationDTM',
        type: 'string',
        map: 'finalModificationDTM',
      },
      {
        name: 'finalModificationUserId',
        type: 'string',
        map: 'finalModificationUserId',
      },
    ],
  }],
  created() {
    this.localdata0 = [];
    this.gridColumns0 = [{
      text: this.$t('MSG_TXT_SN'),
      datafield: 'rowNumber',
      editable: false,
      cellsrenderer: (row, column, value) => `<div style="margin: 8.2px;">${row + 1}</div>`,
      width: '60px',
    }, {
      text: this.$t('MSG_TXT_BBS_NM'),
      datafield: 'bullBoardName',
      width: '150px',
    }, {
      text: this.$t('MSG_TXT_CATG_GRP_ITEM'),
      datafield: 'boardCategoryItemName',
      width: '150px',
    }, {
      text: this.$t('MSG_TXT_NOTICOBJ_TTL'),
      datafield: 'title',
      createwidget: (row, column, value, htmlElement) => {
        utils.getGridCellFactory().createCellStateButton(row, column, value, htmlElement, {
          useSurfixIcon: false,
          handler: this.onClickGrid,
          type: 'link',
        }, this.dataset0, this.$refs.grdList);
      },
      initwidget: (row, column, value, htmlElement) => {
        utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
      },
    }, {
      text: '',
      datafield: 'attchDocId',
      createwidget: (row, column, value, htmlElement) => {
        utils.getGridCellFactory().createCellStateButton(row, column, value, htmlElement, {
          useSurfixIcon: false,
          type: 'link',
        }, this.dataset0, this.$refs.grdList);
      },
      initwidget(row, column, value, htmlElement) {
        utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
      },
      width: 10,
    }, {
      text: this.$t('MSG_TXT_RGST_USR'),
      datafield: 'registrantName',
      createwidget: (row, column, value, htmlElement) => {
        utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
          displayType: '1', // "1", "2" - default: "1"
          type: 'link', // 'link', 'sublink' - default: "link"
          loginId: 'loginId',
        }, this.dataset0, this.$refs.grid);
      },
      initwidget(row, column, value, htmlElement) {
        utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
      },
      width: '200px',
    }, {
      text: this.$t('MSG_TXT_RGST_DTM'),
      datafield: 'firstRegistrationDTM',
      createwidget: (r, c, v, h) => utils.getGridCellFactory().createCellDateLabel(r, c, v, h, this.dataset0, this.$refs.grid),
      initwidget: (r, c, v, h) => utils.getGridCellFactory().refreshCell(r, c, v, h),
      width: '150px',
    }, {
      text: this.$t('MSG_TXT_MDFC_USR'),
      datafield: 'finalModificationUserId',
      createwidget: (row, column, value, htmlElement) => {
        utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
          displayType: '1', // "1", "2" - default: "1"
          type: 'link', // 'link', 'sublink' - default: "link",
          datafieldMap: {
            displayLanguageId: 'fnlDisplayLanguageId',
            knoxId: 'fnlKnoxId',
            userName: 'fnlUserName',
            userGlobalName: 'fnlUserGlobalName',
            departmentName: 'fnlDepartmentName',
            departmentEnglishName: 'fnlDepartmentEnglishName',
            loginId: 'fnlLoginId',
          },
        }, this.dataset0, this.$refs.grid);
      },
      initwidget(row, column, value, htmlElement) {
        utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
      },
      width: '200px',
    }, {
      text: this.$t('MSG_TXT_MDFC_DTM'),
      datafield: 'finalModificationDTM',
      createwidget: (r, c, v, h) => utils.getGridCellFactory().createCellDateLabel(r, c, v, h, this.dataset0, this.$refs.grid),
      initwidget: (r, c, v, h) => utils.getGridCellFactory().refreshCell(r, c, v, h),
      width: '150px',
    }, {
      text: this.$t('MSG_TXT_STT'),
      datafield: 'statusDisplay',
      createwidget: (row, column, value, htmlElement) => {
        utils.getGridCellFactory().createCellButtonList(row, column, value, htmlElement, {
          useSurfixIcon: false,
          handler: this.onClickReject,
        }, this.dataset0, this.$refs.grdList);
      },
      initwidget(row, column, value, htmlElement) {
        utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
      },
      width: 80,
    }];
  },
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {},
  methods: {
    onClickReset() {
      this.$refs.codeSelectSearchCond.reset();
      this.queryData.searchText = '';
      this.rangeDate = { from: '', to: '' };
      this.$refs.codeSelectStatus.reset();
    },
    onClickSearch() {
      if (!this.validateDatePicker()) return false;
      const formattedStartDTM = utils.dateformatToServer(this.rangeDate.from) || '';
      const formattedEndDTM = utils.isEmpty(this.rangeDate.to) ? '' : utils.dateformatToServer(this.rangeDate.to).substr(0, 8).concat('235959');
      const queryParams = {
        postSearchCond: this.queryData.postSearchCond,
        searchText: this.queryData.searchText || '',
        status: this.queryData.status,
        registStartDTM: formattedStartDTM,
        registEndDTM: formattedEndDTM,
      };
      http.request(this.contextPageId, 'DTS_CLB_00025', {
        query: queryParams,
      }).then(res => {
        res.data.forEach(row => {
          const buttonListData = {
            key: 'key',
            label: row.statusDes,
            type: row.status === 'W' ? 'link' : 'label',
          };
          row.statusDisplay = [buttonListData];
          const attchDocId = (row.attchDocId ? true : false);
          row.attchDocId = {
            text: '',
            showattach: attchDocId,
            shownew: false,
          };
          const titlePrefixAnnm = (row.announcementYn === 'Y' ? `[${this.strAnnmYn}]` : '');
          const titlePrefixUgrn = (row.urgentYn === 'Y' ? `[${this.strUgrnYn}]` : '');
          const newTitle = `${titlePrefixUgrn}${titlePrefixAnnm}${row.title}`;
          row.title = { text: newTitle, showattach: false, shownew: false };
        });
        this.dataset0.setRawData(res.data);
      });
    },
    validateDatePicker() {
      if (!this.$refs.datePicker.isValid()) {
        utils.messageBox('warning', this.$t('MSG_ALT_CHK_DT'), null, null);
        return false;
      }
      return true;
    },
    conFirm(type, value, subValue) {
      utils.messageBox(type, value, subValue, this.onClose);
    },
    onClickGrid(btn, dataRow) {
      utils.openLayerPopup('PGE_CLB_00002', this.onRequestInfoCallback, {
        size: 'xlg',
        pageInitialData: {
          postIdParam: dataRow.postId,
          bbsId: dataRow.bbsId,
          postStatus: dataRow.status,
          pageId: 'PGE_CLB_00005',
        },
      });
    },
    onRequestInfoCallback(value) {
      if (value) {
        this.onClickSearch();
      }
    },
    onClickReject(btn, dataRow) {
      if (dataRow.status === 'W') {
        utils.openLayerPopup('PGE_CLB_00010', this.onRequestInfoCallback, {
          size: 'md',
          pageInitialData: {
            postIdParam: dataRow.postId,
            pageId: 'PGE_CLB_00005',
          },
        });
      }
    },
    onKeyUpInput() {
      const searchNewText = this.queryData.searchText;
      if (utils.isExistSpecialChar(searchNewText)) {
        utils.messageBox('warning', this.$t('MSG_ALT_NO_SPECL_CHAR'), null, () => {
          this.queryData.searchText = this.searchOldText;
        });
      } else {
        this.searchOldText = searchNewText;
      }
    },
    onSelectRow(event) {
      if (event.args.row == null || event.args.row === '') return;
      if (event.args.row.postId) {
        this.postId = event.args.row.postId;
      }
      if (event.args.row.status === 'R') {
        this.rejectPermission = false;
      } else {
        this.rejectPermission = true;
      }
    },
    onClickCancel() {
      utils.messageBox('confirm', this.$t('MSG_ALT_PRGS_CANCEL'), null, this.cancelApi);
    },
    cancelApi() {
      http.request(this.contextPageId, 'DTS_CLB_00027', {
        path: {
          'post-id': this.postId,
        },
      }).then(() => {
        this.conFirm('success', this.$t('MSG_ALT_PRGS_OK'), null);
        this.onClickSearch();
      }).catch(error => {
        console.log(error);
      });
    },
  },
};
</script>
<style scoped>
</style>
